"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LoginCookieManager = exports.LT_TOKEN_COOKIE_NAME = exports.LT_REFRESH_TOKEN_COOKIE_NAME = exports.LT_ID_COOKIE_NAME = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _jwtParser = _interopRequireDefault(require("./helpers/jwt-parser"));
var _timeConverter = _interopRequireDefault(require("./helpers/time-converter"));
var _cookieSetter = require("./helpers/cookie-setter");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var LT_TOKEN_COOKIE_NAME = "lt_token";
exports.LT_TOKEN_COOKIE_NAME = LT_TOKEN_COOKIE_NAME;
var LT_REFRESH_TOKEN_COOKIE_NAME = "lt_refresh_token";
exports.LT_REFRESH_TOKEN_COOKIE_NAME = LT_REFRESH_TOKEN_COOKIE_NAME;
var LT_ID_COOKIE_NAME = "lt_id";
exports.LT_ID_COOKIE_NAME = LT_ID_COOKIE_NAME;
var LoginCookieManager = /*#__PURE__*/_createClass(function LoginCookieManager() {
  var _this = this;
  _classCallCheck(this, LoginCookieManager);
  _defineProperty(this, "cookiePrefix", void 0);
  _defineProperty(this, "setCookiePrefix", function (cookiePrefix) {
    _this.cookiePrefix = cookiePrefix;
  });
  _defineProperty(this, "addPrefixIfNeeded", function (cookieName) {
    return _this.cookiePrefix ? "".concat(_this.cookiePrefix, "__").concat(cookieName) : cookieName;
  });
  _defineProperty(this, "getTokenFromCookie", function () {
    return _jsCookie.default.get(_this.addPrefixIfNeeded(LT_TOKEN_COOKIE_NAME));
  });
  _defineProperty(this, "getRefreshTokenFromCookie", function () {
    return _jsCookie.default.get(_this.addPrefixIfNeeded(LT_REFRESH_TOKEN_COOKIE_NAME));
  });
  _defineProperty(this, "getLtidFromCookie", function () {
    return _jsCookie.default.get(_this.addPrefixIfNeeded(LT_ID_COOKIE_NAME));
  });
  _defineProperty(this, "clearTokenCookie", function () {
    return _this.setTokenCookie(undefined, (0, _timeConverter.default)(0));
  });
  _defineProperty(this, "clearRefreshTokenCookie", function () {
    return _this.setRefreshTokenCookie(undefined, (0, _timeConverter.default)(0));
  });
  _defineProperty(this, "clearLtidCookie", function () {
    return _this.setLtidCookie(undefined, (0, _timeConverter.default)(0));
  });
  _defineProperty(this, "setTokenCookie", function (token, expirationAsUTCString) {
    (0, _cookieSetter.setCookie)(_this.addPrefixIfNeeded(LT_TOKEN_COOKIE_NAME), token, expirationAsUTCString);
  });
  _defineProperty(this, "setRefreshTokenCookie", function (refreshToken, expirationAsUTCString) {
    (0, _cookieSetter.setCookie)(_this.addPrefixIfNeeded(LT_REFRESH_TOKEN_COOKIE_NAME), refreshToken, expirationAsUTCString);
  });
  _defineProperty(this, "setLtidCookie", function (ltid, expirationAsUTCString) {
    (0, _cookieSetter.setCookie)(_this.addPrefixIfNeeded(LT_ID_COOKIE_NAME), ltid, expirationAsUTCString);
  });
  _defineProperty(this, "isTokenExpiredOrCleared", function () {
    var token = _this.getTokenFromCookie();
    if (!token) {
      return true;
    }
    var _parseJwt = (0, _jwtParser.default)(token),
      exp = _parseJwt.exp;
    if (!exp) {
      return true;
    }
    var now = new Date().getTime();
    return now > exp * 1000;
  });
});
exports.LoginCookieManager = LoginCookieManager;
var _default = new LoginCookieManager();
exports.default = _default;